module.exports = __webpack_public_path__ + "img/11.4028c3e8.jpg";